'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _utilElement = require('utils/util-element');

require('whatwg-fetch');

var _reactTapEventPlugin = require('react-tap-event-plugin');

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactTapEventPlugin2.default)();

var App = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    if ((0, _utilElement.checkDevice)()) {
      console.log('Mobile device detected!!');
      document.body.addEventListener('focus', _this.focusHandler, true);
      document.body.addEventListener('blur', _this.blurHandler, true);
    }
    var doc = document.body || document.documentElement;
    var style = doc.style;

    if (style.webkitFlexWrap === '' || style.msFlexWrap === '' || style.flexWrap === '') {
      doc.className += ' supports-flex';
    }
    return _this;
  }

  App.prototype.focusHandler = function focusHandler(event) {
    if (event && event.target) {
      var node = event.target.nodeName ? event.target.nodeName.toLowerCase() : '';
      var type = event.target.type ? event.target.type.toLowerCase() : '';
      if ((node === 'input' || node === 'textarea') && type !== 'checkbox' && type !== 'radio') {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          // document.body.addEventListener('touchmove', function clbk(scrollEvent) {scrollEvent.preventDefault();}, false);
        } else {
          document.body.className = 'mobile_device';
        }
      }
    }
  };

  App.prototype.blurHandler = function blurHandler(event) {
    if (event && event.target) {
      var node = event.target.nodeName ? event.target.nodeName.toLowerCase() : '';
      var type = event.target.type ? event.target.type.toLowerCase() : '';
      if ((node === 'input' || node === 'textarea') && type !== 'checkbox' && type !== 'radio') {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          // document.body.removeEventListener('touchmove', function clbk(scrollEvent) {scrollEvent.preventDefault();}, false);
        } else {
          setTimeout(function clbk() {
            document.body.className = document.body.className.replace(/\bmobile_device\b/, '');
          }, 300);
        }
      }
    }
  };

  App.prototype.render = function render() {
    var styles = require('./App.scss');
    return _react2.default.createElement(
      'div',
      { className: styles.app },
      _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
      _react2.default.createElement(
        'div',
        { className: styles.appContent },
        _react2.default.createElement(
          'div',
          { style: { height: '100%', width: '100%' } },
          this.props.children
        )
      )
    );
  };

  return App;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object
}, _temp);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1576
// module chunks = 0